import { FormGroup } from "@angular/forms";

export class PaymentCollectionRequest {
    userId: string;
    generatedLoanId?: string;
    amount: number;
    paymentProduct: PaymentProduct;
    paymentMode: PaymentMode;
    paymentDetails?: PaymentDetails;
}

export enum PaymentProduct {
    LOAN_EMI_PAYMENT = 'LOAN_EMI_PAYMENT', UPDATE_LENDER_WALLET = 'UPDATE_LENDER_WALLET'
}

export enum PaymentMode {
    DEBIT_CARD_SAVED = 'DEBIT_CARD_SAVED', DEBIT_CARD = 'DEBIT_CARD', NET_BANKING = 'NET_BANKING', UPI = 'UPI',
}

export enum PaymentModeDisplay {
    NET_BANKING = 'Net Banking',
    DEBIT_CARD = 'Debit Card',
    UPI = 'UPI'
}

export enum Month {
    JANUARY = '01', FEBRUARY = "02", MARCH = "03", APRIL = "04",
    MAY = "05", JUNE = "06", JULY = "07", AUGUST = "08", SEPTEMBER = "09",
    OCTOBER = "10", NOVEMBER = "11", DECEMBER = "12"
}

export interface PaymentCollectionResponseByTransactionId {
    status: string;
    paymentMode: string;
    amount: number;
    transactionId: string;
    bankReferenceNumber: string;
}

export interface PaymentCollectionResponseByProfileId {
    createdAt: string;
    status: string;
    amount: number;
    paymentMode: string;
    transactionId: string;
}

export interface PaymentCollectionResponseByProfileIdForTable {
    createdAt: string;
    time: string;
    status: string;
    amount: number;
    paymentMode: string;
    transactionId: string;
}

export interface UPIPaymentDetails {
    vpa: string;
}

export interface CardPaymentDetails {
    cardNumber: string;
    cardHolderName: string;
    cardCVV: string;
    cardExpiryMonth: string;
    cardExpiryYear: string;
    cardType: string;
    storedCardToken?: string;
    rememberCard: boolean;
}

export class PaymentDetails {
    paymentIssuerCode?: string;
    upiDetails?: UPIPaymentDetails;
    cardDetails?: CardPaymentDetails;
}

export class VerifyPaymentLinkResponse {
    profileId: string
}

export interface PaymentCollectionResponse {
    metaData: {
        message: string;
        referenceId: string;
        statusCode: string;
        txnId: string;
        txnStatus: string;
        unmappedStatus: string;
    };
    result: {
        otpPostUrl: string;
        acsTemplate: string;
    };
    binData: {
        pureS2SSupported: string;
        issuingBank: string;
        category: string;
        cardType: string;
        isDomestic: string;
    };
}

export class TabChangeCallback {
    index: number;
    currentFormInstance: FormGroup;
}

export class SavedCardDetail {
    status: number;
    user_cards: {}
}

export interface CardDetail {
    expiry_month: string,
    card_mode: string,
    card_no: string,
    card_token: string,
    card_name: string,
    card_type: string,
    expiry_year: string,
    card_brand: string,
    card_bin: string,
    isDomestic: string,
    is_expired: string,
    card_cvv: string
}

export interface CardBinDetails {
    isDomestic: string;
    issuingBank: string;
    cardType: string;
    cardCategory: string;
}

export enum CardTypeCode {
    RUPAY = "RUPAY",
    VISA = "VISA",
    MAST = "MAST", // Master card
    MAES = "MAES", // Meastro Card
    SMAE = "SMAE", // SBI Meastro Card
}
export enum CardCategory {
    DC = "DC",
    CC = "CC",
}
